/* MOG MINTS, formula scroll.
   One scroll position drives two things: which frame of the break is on screen, and how far
   each active has risen out of it. They are the same number, so the reveal cannot drift out of
   sync with the mint. */
(function () {
  var track = document.querySelector('.formula-scroll');
  if (!track) return;

  var canvas = track.querySelector('.mint-stage canvas');
  var actives = track.querySelector('.actives');
  var ctx = canvas.getContext('2d', { alpha: false });
  var rows = [].slice.call(track.querySelectorAll('.active'));

  var FRAMES = 97;
  var FIRST = 15;   /* the frame the crack opens from; 0 to 15 are the mint at rest (under 1.2/255 apart) */
  var SRC = function (i) {
    /* ⚠ SHOPIFY ASSETS ARE FLAT, there are no subfolders, so assets/mint/seq/
       collapsed to a "mintsplit-" filename prefix at the port. The base URL is
       injected by the section (window.MOG_SPLIT_BASE) because Liquid, not JS,
       knows the CDN path.
       NOT "mintseq-" and NOT MOG_SEQ_BASE: those belong to the boom section, whose
       121 frame break is a different render at 780x682 with alpha. Sharing the
       prefix overwrote 96 of boom's frames once (2026-09-12); caught before it
       shipped. */
    var base = window.MOG_SPLIT_BASE || '';
    return base + 'mintsplit-m_' + String(i).padStart(3, '0') + '.webp';
  };
  var FRAME_W = 560, FRAME_H = 996;

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* the stacked layout, below the 860px where base.css turns the stage into one column */
  var mqStack = matchMedia('(max-width: 860px)');

  /* ---- each active owns a slice of the scroll ----
     START: where the first active begins to rise. The mint's crack completes by ~0.20, so
     starting at 0.08 puts the first names in motion while it is still splitting rather than
     waiting politely for it to finish.
     STEP: gap between consecutive actives. SPAN: how long one takes to rise and settle.

     Tuned for SPEED: the names snap in rather than drift. SPAN 0.10 means one rises and settles
     in a tenth of the track; STEP 0.105 means the next is already moving before the last lands,
     so they arrive as a burst, not a queue.

     That finishes the actives at p=0.63, and the remaining track is NOT dead, the mint is still
     drifting to its final pose there, which is the whole back half of the clip. The earlier
     "dead scroll" problem was really the sticky bug (overflow-x:hidden), now fixed. */
  var START = 0.05, STEP = 0.105, SPAN = 0.10;
  var win = rows.map(function (_, i) {
    return { a: START + i * STEP, b: START + i * STEP + SPAN };
  });

  /* ---- frame store ---- */
  var imgs = new Array(FRAMES);
  var ready = new Array(FRAMES);
  var drawn = -1;

  function load(i, cb) {
    if (imgs[i]) return;
    var im = new Image();
    im.decoding = 'async';
    im.onload = function () { ready[i] = true; if (cb) cb(); };
    im.src = SRC(i);
    imgs[i] = im;
  }

  function paint(i) {
    if (i === drawn || !ready[i]) return;
    ctx.drawImage(imgs[i], 0, 0, canvas.width, canvas.height);
    drawn = i;
  }
  /* Two adjacent frames, the second at a fractional weight: the crack opens in one frame step
     (17/255 between frames 14 and 15, the largest in the sequence), and a plain step there read
     as a cut after the flip's slow settle. Used over the first stretch of the track only. */
  function blend(lo, frac) {
    ctx.drawImage(imgs[lo], 0, 0, canvas.width, canvas.height);
    ctx.globalAlpha = frac;
    ctx.drawImage(imgs[lo + 1], 0, 0, canvas.width, canvas.height);
    ctx.globalAlpha = 1;
    drawn = -1;
  }

  /* Nearest already-decoded frame, so a fast flick shows the closest thing it has instead of
     freezing on a stale one while the exact frame decodes. */
  function nearestReady(i) {
    if (ready[i]) return i;
    for (var d = 1; d < FRAMES; d++) {
      if (ready[i - d]) return i - d;
      if (ready[i + d]) return i + d;
    }
    return -1;
  }

  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function smooth(t) { return t * t * (3 - 2 * t); }

  /* ---- directional blur ----
     CSS blur() is isotropic and would smear the type sideways as well as vertically, which
     reads as out-of-focus rather than moving. An SVG feGaussianBlur with stdDeviation="0 N"
     blurs on Y only: actual motion blur along the axis of travel.
     The filter is attached only while a row is in flight and removed once it lands, so at most
     one or two elements ever carry one. */
  var blurFilter = document.getElementById('mint-mb-blur');

  /* How much X to mix into the smear, as a fraction of Y. Read from CSS so each type direction
     owns its own value: an italic face wants the blur raked along its lean, an upright one
     wants none.
     Cached, not read per frame, getComputedStyle in the scroll path would force a style
     recalc on every tick. Only re-read when the direction actually changes. */
  var _mbX = 0;
  function readMbX() {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mb-x'));
    _mbX = isNaN(v) ? 0 : v;
  }
  function mbX() { return _mbX; }
  readMbX();
  new MutationObserver(function () { readMbX(); render(); })
    .observe(document.documentElement, { attributes: true, attributeFilter: ['data-type'] });

  function render() {
    var r = track.getBoundingClientRect();
    var scrollable = track.offsetHeight - window.innerHeight;
    var p = clamp01(scrollable > 0 ? -r.top / scrollable : 0);

    /* HIDDEN UNTIL PINNED (2026-09-14). This section is pulled up under the What section's tail,
       and until its stage pins the canvas would rise through the screen beside the flip's pinned
       mint. It shows the instant the section's top reaches the viewport top, on the same pixels
       the flip stage holds, so the eye sees one mint.

       ⚠ THAT IS A DESKTOP DEVICE AND ONLY A DESKTOP DEVICE (2026-09-18). The hide exists purely
       because of the -100svh pull, and base.css sets margin-top:0 below 900px, so on a phone
       there is no overlap to hide from and nothing above to be confused with. What the hide did
       there instead was leave an empty stage for a whole screen before the mint arrived, which
       is Ashot's "the mint doesnt appear here at first". Below the stacking breakpoint the
       canvas is simply always on: p is 0 until the track starts moving, which paints frame
       FIRST, the mint whole and at rest, so the reader meets the intact mint and then watches
       it break. */
    canvas.style.visibility = (!mqStack.matches && r.top > 1) ? 'hidden' : '';
    track.classList.toggle('is-pinned', r.top <= 1);
    /* the copy fades in over the last quarter of the pulled-up screen, once the last card is gone */
    if (actives) actives.style.opacity = r.top <= 0 ? '' : String(clamp01(1 - r.top / (window.innerHeight * 0.25)));

    /* mint */
    /* FIRST (2026-09-14): frames 0 to 15 are the mint at rest (frame-to-frame difference under
       1.2/255; the crack opens between 15 and 16) and the flip lands on that pose, so the split
       begins moving at the pin. */
    /* SLOW-IN (2026-09-14): the first moving frames carry the crack, the largest change in the
       sequence, and they landed at full speed right after the flip's slow settle. Over the first
       15% of the track the frame rate starts at 10% and reaches full speed smoothly (a cubic
       Hermite: value 0 to 0.15, slope 0.1 to 1). The actives keep their own timing on p. */
    var g = p;
    if (p < 0.15) { var t = p / 0.15; g = 0.15 * ((t * t * t - 2 * t * t + t) * 0.1 + (-2 * t * t * t + 3 * t * t) + (t * t * t - t * t)); }
    var fi = FIRST + g * (FRAMES - 1 - FIRST);
    var f = Math.round(fi), lo = Math.floor(fi), frac = fi - lo;
    var blended = p < 0.08 && ready[lo] && ready[lo + 1] && frac > 0.02 && frac < 0.98;
    if (blended) { blend(lo, frac); }
    else { var use = nearestReady(f); if (use >= 0) paint(use); }
    canvas.dataset.frame = fi.toFixed(2) + (blended ? ' blend' : ' paint');   /* read by the harness checks */

    /* actives */
    for (var i = 0; i < rows.length; i++) {
      var w = win[i];
      var t = clamp01((p - w.a) / (w.b - w.a));
      var e = smooth(t);
      var row = rows[i];

      row.style.opacity = e;
      row.style.transform = 'translate3d(0,' + ((1 - e) * 40).toFixed(2) + 'px,0)';

      /* Blur tracks distance-still-to-travel, so it is strongest at the start of the rise and
         gone the instant the row settles. */
      if (t > 0 && t < 1) {
        row.style.filter = 'url(#mint-motion-blur)';
      } else if (row.style.filter) {
        row.style.filter = '';
      }
    }

    /* One shared filter value: the fastest-moving row sets it. Six live SVG filters would cost
       more than the effect is worth, and in practice rows overlap by only a few percent. */
    var maxBlur = 0;
    for (var j = 0; j < rows.length; j++) {
      var tj = clamp01((p - win[j].a) / (win[j].b - win[j].a));
      if (tj > 0 && tj < 1) maxBlur = Math.max(maxBlur, (1 - smooth(tj)) * 13);
    }
    /* Oblique directions (velocity) set --mb-x, so the smear travels along the lean of the type
       instead of straight up through it. Upright directions leave it 0 and get pure Y. */
    if (blurFilter) {
      blurFilter.setAttribute('stdDeviation',
        (maxBlur * mbX()).toFixed(2) + ' ' + maxBlur.toFixed(2));
    }
  }

  /* ---- sizing ----
     Bails on a zero box rather than writing a 0x0 buffer it can never recover from. That
     happens whenever the element is laid out after this script runs: a restored tab, a lazy
     container, display:none at boot. */
  function size() {
    var box = canvas.getBoundingClientRect();
    if (!box.width || !box.height) return false;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.round(box.width * dpr), h = Math.round(box.height * dpr);
    if (w === canvas.width && h === canvas.height) return true;
    canvas.width = w;
    canvas.height = h;
    drawn = -1;              /* buffer is cleared by the resize; force a repaint */
    return true;
  }

  /* ---- boot ----
     First frame first so the mint is on screen immediately, then the rest in the background.
     Nobody reaches the scrub before it is filled in. */
  load(FIRST, function () { if (size()) render(); });

  var next = 1;
  function fill() {
    if (next >= FRAMES) return;
    var i = next++;
    load(i, function () { if (i === drawn + 1) render(); fill(); });
  }
  if ('requestIdleCallback' in window) requestIdleCallback(function () { for (var k = 0; k < 4; k++) fill(); });
  else setTimeout(function () { for (var k = 0; k < 4; k++) fill(); }, 200);

  /* ---- supplement label lightbox ----
     The doses are a claim; the label is the receipt. Kept in this file because it belongs to
     this section and nothing else opens it.
     Focus is captured and returned: a dialog you can tab out of behind the overlay is worse
     than no dialog. Scroll is locked while it is open, because this section is a scroll
     mechanism and letting the page scrub behind a modal is disorienting. */
  (function labelBox() {
    var box = document.getElementById('label-box');
    var opener = track.querySelector('[data-label-open]');
    if (!box || !opener) return;
    var closer = box.querySelector('[data-label-close]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      box.hidden = false;
      /* Force a reflow so the transition has a from-state, rather than deferring to rAF.
         rAF is paused in a background/throttled tab, and if it never fires the dialog is left
         scroll-locked but invisible, the user is trapped behind nothing. This is synchronous
         and cannot be skipped. */
      void box.offsetWidth;
      box.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
      closer.focus();   /* safe now: data-open is set, so it is visible and focusable */
      document.addEventListener('keydown', onKey);
    }
    function close() {
      box.removeAttribute('data-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus) lastFocus.focus();

      /* Re-hide after the fade, but never depend on transitionend alone: if the transition is
         disabled (reduced motion, a throttled tab) it never fires and the dialog stays in the
         accessibility tree forever. Whichever lands first wins. */
      var done = false;
      var hide = function () {
        if (done) return;
        done = true;
        box.hidden = true;
        box.removeEventListener('transitionend', hide);
      };
      box.addEventListener('transitionend', hide);
      setTimeout(hide, 400);   /* transition is 220ms */
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      /* only two focusables in here, so the trap is just: keep it on the close button */
      e.preventDefault();
      closer.focus();
    }

    opener.addEventListener('click', open);
    closer.addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
  })();

  if (reduced) {
    rows.forEach(function (r) { r.style.opacity = 1; r.style.transform = 'none'; });
    load(FRAMES - 1, function () { if (size()) paint(FRAMES - 1); });
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { if (size()) paint(FRAMES - 1); }).observe(canvas);
    }
    return;   /* the mint rests broken open; no scrub, no blur */
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; render(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ResizeObserver rather than window.resize: it fires when the canvas itself first gets a
     size, which window.resize does not, and it also catches layout changes that never touch
     the window (a sidebar opening, a font landing and reflowing the column). */
  if ('ResizeObserver' in window) {
    new ResizeObserver(function () { if (size()) render(); }).observe(canvas);
  } else {
    window.addEventListener('resize', function () { if (size()) render(); }, { passive: true });
  }
  render();
})();
